/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Reason_CompetitorInputs */

const en_cancel_reason_competitor = /** @type {(inputs: Cancel_Reason_CompetitorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Found a better alternative`)
};

const de_cancel_reason_competitor = /** @type {(inputs: Cancel_Reason_CompetitorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine bessere Alternative gefunden`)
};

const fr_cancel_reason_competitor = /** @type {(inputs: Cancel_Reason_CompetitorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J'ai trouve une meilleure alternative`)
};

const es_cancel_reason_competitor = /** @type {(inputs: Cancel_Reason_CompetitorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre una mejor alternativa`)
};

const it_cancel_reason_competitor = /** @type {(inputs: Cancel_Reason_CompetitorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ho trovato un'alternativa migliore`)
};

const nl_cancel_reason_competitor = /** @type {(inputs: Cancel_Reason_CompetitorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beter alternatief gevonden`)
};

const pl_cancel_reason_competitor = /** @type {(inputs: Cancel_Reason_CompetitorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znalazlem lepsza alternatywe`)
};

const fi_cancel_reason_competitor = /** @type {(inputs: Cancel_Reason_CompetitorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loysin paremman vaihtoehdon`)
};

const da_cancel_reason_competitor = /** @type {(inputs: Cancel_Reason_CompetitorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fandt et bedre alternativ`)
};

const sv_cancel_reason_competitor = /** @type {(inputs: Cancel_Reason_CompetitorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hittade ett bättre alternativ`)
};

/**
* | output |
* | --- |
* | "Found a better alternative" |
*
* @param {Cancel_Reason_CompetitorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_reason_competitor = /** @type {((inputs?: Cancel_Reason_CompetitorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Reason_CompetitorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_reason_competitor(inputs)
	if (locale === "fr") return fr_cancel_reason_competitor(inputs)
	if (locale === "es") return es_cancel_reason_competitor(inputs)
	if (locale === "it") return it_cancel_reason_competitor(inputs)
	if (locale === "nl") return nl_cancel_reason_competitor(inputs)
	if (locale === "pl") return pl_cancel_reason_competitor(inputs)
	if (locale === "fi") return fi_cancel_reason_competitor(inputs)
	if (locale === "da") return da_cancel_reason_competitor(inputs)
	if (locale === "sv") return sv_cancel_reason_competitor(inputs)
	return en_cancel_reason_competitor(inputs)
});